import { TranslationsContext } from '@teliaee/telia-translate';
import { inject, observer } from 'mobx-react';
import React, { useContext } from 'react';
import {
  AnalyticsTrigger,
  Button,
  Icon,
  EqualHeight,
  Heading,
  Card,
  CardContent,
  ModalProvider,
  ModalTrigger,
  Separator,
  THeadingLevel
} from 'telia-front-react';
import PersonalOffersStore from '../../../stores/PersonalOffersStore';
import B2BGravityFormModal from '../B2BGravityFormModal';

interface B2BOfferCardProps {
  missing?: boolean;
  suffix?: string;
  mainIcon?: string;
  children: JSX.Element;
  personalOffersStore?: PersonalOffersStore;
  mobile: boolean;
  b2bMobileFormName?: string;
  b2bInternetFormName?: string;
  headingLevel?: THeadingLevel;
}

const B2BOfferCard = (props: B2BOfferCardProps): JSX.Element => {
  const { translate } = useContext(TranslationsContext);
  const { missing, suffix, mainIcon, children, mobile, b2bMobileFormName, b2bInternetFormName, headingLevel } = props;

  return (
    <Card background="neutral-bg-level-1">
      <CardContent
        tagTop={{
          text: missing ? translate('personalOffers.telia1.badge.missing') : translate('personalOffers.telia1.badge.exists'),
          purpose: missing ? 'error' : 'success'
        }}
      >
        <EqualHeight group={'b2b-offer-header'}>
          <Icon size="sm" modifiers={mainIcon} />
          <Heading className="h4 text-break" level={headingLevel}>
            {translate(`personalOffers.b2b.card.${suffix}`)}
          </Heading>
          <Separator spacing="xxsmall" color="invisible" />
        </EqualHeight>
        <EqualHeight group={'b2b-offer-content'}>{children}</EqualHeight>
        <EqualHeight group={'b2b-offer-footer'}>
          {missing && (
            <>
              <Separator spacing="xsmall" color="invisible" />
              <AnalyticsTrigger trigger={{ id: `Link - Modal - Telia äriklass ${suffix}`, callback: 'onOpen' }}>
                <ModalProvider>
                  <ModalTrigger>
                    <Button text={translate('personalOffers.b2b.button.join')} iconRight="#arrow-right" block={true} />
                  </ModalTrigger>
                  <B2BGravityFormModal formName={mobile ? b2bMobileFormName : b2bInternetFormName} />
                </ModalProvider>
              </AnalyticsTrigger>
            </>
          )}
        </EqualHeight>
      </CardContent>
    </Card>
  );
};
export default inject('personalOffersStore')(observer(B2BOfferCard));
